import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import InspectionItem from '../InspectionItem'

// Constants
import { triggerPopup } from '../../../../actions/backdrop'
import { translation } from '../../../../utils/helpers'

// Elements
import Check from '../../../../shared/elements/check'
import Text from '../../../../shared/elements/text'

class Color extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
    }
    this.renderContent = this.renderContent.bind(this)
  }

  componentDidMount () {
  }
  componentWillReceiveProps (nextProps) {
  }
  renderContent () {
    const onChange = (e) => {
      let propName = 'Color'
      if (this.props.isBodyshop) propName = 'BodyshopColor'
      this.props.onChange(propName, e)
    }
    const onBlur = (e) => {
      this.props.onBlur(e)
    }
    const renderItem = (key, name) => {
      // let colorIcon = null
      let value = this.props.color ? (this.props.color[name] || '') : ''
      // if (name === 'Color') {
      //   colorIcon = <span className='right'><img src='/images/svgs/color/Color.svg' title={translation('179')} style={{ width: 20, height: 20 }} /></span>
      // }
      // if (name === 'Code') {
      //   colorIcon = <span className='right'><img src='/images/svgs/color/Color_code.svg' title={translation('79')} style={{ width: 20, height: 20 }} /></span>
      // }
      // if (name === 'Variant') {
      //   colorIcon = <span className='right'><img src='/images/svgs/color/color-variation.svg' title={translation('13388')} style={{ width: 20, height: 20 }} /></span>
      // }
      // if (name === 'Amount') {
      //   colorIcon = <span className='right'><img src='/images/svgs/color/Color_amount-VS.svg' title={translation('13392')} style={{ width: 20, height: 20 }} /></span>
      // }

      const disabled = (name === 'Amount' && this.props.order.IsReferredOut)

      return (
        <Text labelText={translation(key)} value={value} name={name} onChange={onChange} onBlur={onBlur} disabled={disabled} />
      )
    }
    return (
      <div>
        {renderItem('179', 'Color')}
        {renderItem('79', 'Code')}
        {!this.props.isBodyshop && renderItem('13388', 'Variant')}
        {!this.props.isBodyshop && renderItem('13392', 'Amount')}
        {/* <span className='right'><img src='/images/svgs/color/Color-ok.svg' title={translation('13393')} style={{ width: 20, height: 20 }} /></span> */}
        {!this.props.isBodyshop && (
          <Check labelText={translation('13393')} id='IsReady' name='IsReady' value='1' checked={this.props.color.IsReady} onChange={onChange} disabled={this.props.order.IsReferredOut} />)}
      </div>
    )
  }
  render () {
    // if (!this.props.color) return null
    let title = {
      icon: '/images/svgs/inspection/color.svg',
      text: '179'
    }
    const headerClick = () => {
      let color = 'Color'
      if (this.props.isBodyshop) color = 'BodyshopColor'
      this.props.onHeaderClick(color)
    }
    return (
      <InspectionItem title={title} renderContent={this.renderContent} checked={this.props.color ? this.props.color.Checked : false} onHeaderClick={headerClick} />
    )
  }
}

Color.defaultProps = {
  isBodyshop: false
}

Color.propTypes = {
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  // color: React.PropTypes.object.isRequired,
  onHeaderClick: PropTypes.func.isRequired,
  isBodyshop: PropTypes.bool,
  order: PropTypes.object.isRequired
}

Color.contextTypes = {
  router: PropTypes.object.isRequired
  // t: React.PropTypes.func.isRequired,
  // enum: React.PropTypes.func.isRequired
}
function mapStateToProps (state) {
  return {
    auth: state.auth,
    order: state.orders.order
  }
}
export default connect(mapStateToProps, {
  triggerPopup
})(Color)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderInspection/Color/index.js